// extracted by mini-css-extract-plugin
export default {"modal":"EJsdQRJ0AFq5Xdkyp1rd","titleWrapper":"ep6EfFgwM0MHHlqpFKas","resetToOriginalAmountButton":"oyGDrfNNu6MYb_O18PK6"};